import axios from "axios";

const state = {
    faqHomePosts: [],
    faqAllPosts: [],
};

const getters = {
    getFAQHomePosts: (state) => {
        return state.faqHomePosts;
    },
    getFAQAllPosts: (state) => {
        return state.faqAllPosts;
    }
};

const actions = {};

const mutations = {
    SET_FAQS_HOME(state) {
        return axios
            .get(
                `https://news.spacesaver.com/api/faqs?sort[0]=publishedAt:desc&pagination[limit]=6`
            )
            .then((response) => {
                //console.log(response);
                state.faqHomePosts = response.data.data;
            });
    },
    SET_FAQS_ALL(state) {
        return axios
            .get(
                `https://news.spacesaver.com/api/faqs?sort[0]=publishedAt:desc`
            )
            .then((response) => {
                //console.log(response);
                state.faqAllPosts = response.data.data;
            });
    },
    UPDATE_FAQS_HOME(state, data) {      
        state.faqHomePosts = data;
    },
    UPDATE_FAQS_ALL(state, data) {      
        state.faqAllPosts = data;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}